import logo from "./logo.svg";
import './utils/testAutopayError'; // Import for console testing
import "./App.css";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { SnackbarProvider } from "notistack";

import { store } from "./store";
import { AuthProvider } from "./providers/AuthProvider";
import Notifier from "./components/Notifier";
import ErrorBoundary from "./components/ErrorBoundary";
import { initializeAuthListener } from "./firebase_config";
import router from "./routes";
import theme from "./theme";
import errorReporter from "./utils/errorReporting";
import { testTelegramAlerts } from "./utils/testErrorReporting";

// Make testing functions available in console for development
if (process.env.NODE_ENV === 'development') {
  window.testTelegramAlerts = testTelegramAlerts;
  window.errorReporter = errorReporter;
}

initializeAuthListener(store);


function App() {
  return (
    <ErrorBoundary component="App" fallbackMessage="The HOA management system encountered an unexpected error. Please refresh the page or contact support if the problem persists.">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Provider store={store}>
          <SnackbarProvider maxSnack={3}>
            <Notifier />
            <AuthProvider>
              <ErrorBoundary component="AuthProvider">
                <RouterProvider router={router} />
              </ErrorBoundary>
            </AuthProvider>
          </SnackbarProvider>
        </Provider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
